import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import ActionForm from '../components/ActionForm';
import CompanyUpdateForm from '../components/CompanyUpdateForm';
import ActionClosingForm from '../components/ActionClosingForm';


var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;


var token= ''
var bizuserid= ''


class ActionStatuses_ForApplication extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    action_statuses: [],
    datarequested:true,
  };

  componentDidMount(){
    this.comp_reloaded()
  }

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  this.setState({datarequested:false})




}


getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};



  render() {
    const columns = [
      {
        title: 'Date',
        dataIndex: 'logged_at',
        key: 'id',
        ...this.getColumnSearchProps('logged_at'),
      },
     
      {
        title: 'Action',
        dataIndex: 'action_name',
        key: 'id',
        ...this.getColumnSearchProps('action_name'),
      },
     
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'id',
        ...this.getColumnSearchProps('status'),
      },
      {
        title: 'Application ID',
        dataIndex: 'application_ID',
        key: 'id',
        ...this.getColumnSearchProps('application_ID'),
      },
      {
        title: 'Workflow',
        dataIndex: 'workflow_name',
        key: 'id',
        ...this.getColumnSearchProps('workflow_name'),
      },
      
      {
        title: 'Due date',
        dataIndex: 'due_date',
        key: 'id',
      },
      {
        title: 'Completed At',
        dataIndex: 'completed_at',
        key: 'id',
      }
     
    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

          <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >
            
             <TabPane tab={"All Actions"} key="1">
                <p>There are {this.props.action_statuses.length}  Actions </p>
                <Table 
                  columns={columns} 
                  scroll={{ x: 1000 }}
                  pagination={{showQuickJumper:true,showSizeChanger:true }}
                  dataSource={this.props.action_statuses}
                  bordered

                  expandable={{
                    expandedRowRender: (record) =>{
                        return (
                          <div>
                          </div>
                        );
                    } ,
                    rowExpandable: (record) => true,
                    onExpand:(condition,record)=>{
                    },

                  }}
                  />
              </TabPane>
            </Tabs>
        </div>
        )
    }
   
  }
}

export default ActionStatuses_ForApplication; 
